export default "__VITE_ASSET__BjU5pdP7__"